function Loading() {
  return (
    <div className="loading_section">
      <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
  );
}

export default Loading;
